
import { ReportInfo } from "../interface/ReportInfoInterface";

//methodology links
import cddrMethodology from "./../downloads/CDDR-methodology.pdf";
import slfsMethodology from "./../downloads/SLFS-methodology.pdf";
import cdfsMethodology from "./../downloads/CDFS-methodology.pdf";

/**
 * All Reports and respective properties
 * */


export const Reports: ReportInfo[] = [
    {
        nameID: "CONGRESSIONAL_DISTRICT_DETAIL_REPORT",
        fullName: "Congressional District Detail Report",
        urlPath: "/reports/congressional-district-detail-report",
        methodologyUrl: cddrMethodology,
        downloadDataAction: null,
        downloadPDFAction: null,
        shareReportAction: null,
        latestReleaseDate: "January, 2024",
        isSharedReport: false
    },
    {
        nameID: "STATE_LEGISLATIVE_FACTSHEET",
        fullName: "State Legislative Fact Sheet",
        urlPath: "/reports/factsheet/stateLegislative",
        methodologyUrl: slfsMethodology,
        downloadDataAction: null,
        downloadPDFAction: null,
        shareReportAction: null,
        latestReleaseDate: "January, 2024",
        isSharedReport: false
    },
    {
        nameID: "CONGRESSIONAL_DISTRICT_FACTSHEET",
        fullName: "Congressional District Fact Sheet",
        urlPath: "/reports/factsheet",
        methodologyUrl: cdfsMethodology,
        downloadDataAction: null,
        downloadPDFAction: null,
        shareReportAction: null,
        latestReleaseDate: "January, 2024",
        isSharedReport: false
    },
    {
        nameID: "EMPLOYEE_PROFILE_REPORT_STEPPING_BLOCKS",
        fullName: "Employee Profile Report (Stepping Blocks)",
        urlPath: "/reports/employee-report",
        methodologyUrl: "",
        downloadDataAction: null,
        downloadPDFAction: null,
        shareReportAction: null,
        latestReleaseDate: "June, 2022",
        isSharedReport: false
    }
];


/**
 * Finds a report's information via the current url
 * @param url
 */
export const findReportViaURLPath = (url: string) => {

    const reportInfo = Reports.find(report => report.urlPath === url || url.includes(report.urlPath));

    if (reportInfo.urlPath !== url) reportInfo.isSharedReport = true;

    return reportInfo;
}